import { getParamsFromSessionStorage } from './sessionUtils'

export default getParamsFromSessionStorage
export const getInitialData = async () => {
  try {
    const {
      routingKey,
      Channel,
      Language,
      returnURL,
      LogoutURL,
      AFTokenValue,
      deviceAppVersion,
      AccessToken,
      correlationID,
      billpayDeepLink
    } = await getParamsFromSessionStorage()

    return {
      routingKey,
      Channel,
      Language,
      returnURL,
      LogoutURL,
      AFTokenValue,
      deviceAppVersion,
      AccessToken,
      correlationID,
      billpayDeepLink
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.info('unable to get the getParamsFromSessionStorage', error)
  }
  return null
}
